const API_BASE = '_api/v2.0';
export const API_DRIVE_BASE = `${API_BASE}/drive`;

export const API_BASE_FOR_SHARES = `${API_BASE}/shares`;

export const API_BASE_FOR_PATH = `${API_DRIVE_BASE}/root`;
export const API_BASE_FOR_ID = `${API_DRIVE_BASE}/items`;

export const ROOT_FOLDER_ID = 'root';

// This endpoint is taken from how we make calls from the server to ODC. This
// has not been tested from the client side as currently we are unable to make
// ODC client side calls because we are unable to get the OAuth token for consumer
// accounts. Once we support that then we can test and enable client side calls
// for 1st party ODC.
export const ONE_DRIVE_CONUSMER_API_URL = 'https://s2s-api.onedrive.com';

// 10MB. One drive recommends that the slize size should be 5-10MB and it should be multiple
// of 320 KB.
export const DEFAULT_UPLOAD_SLICE_SIZE = 10 * 1024 * 1024;
